import { lazy, Suspense } from 'react';

import { Loading } from './loading';

const Auth = lazy(() => import('./auth'));

export function AuthPage() {
  return (
    <Suspense fallback={<Loading />}>
      <Auth />
    </Suspense>
  );
}
